import React from 'react'
import { Image, Avatar, message } from 'antd';
import Icon, { LeftOutlined, UserOutlined, MessageOutlined, HeartOutlined } from '@ant-design/icons';
import intl from 'react-intl-universal';

import { timeFormat } from '../../../utils'
import { uniqBy } from 'lodash'

import Nav from '../../../component/nav/nav'
import Banner from '../../../component/Banner/Banner'
import FilterComponent from '../../../component/FilterComponent/FilterComponent'
import BreadCrumb from '../../../component/BreadCrumb/BreadCrumb'
import APagination from '../../../component/Pagination/Pagination'
import PopupSearch from '../../../component/PopupSearch/PopupSearch'
import LeftTool from '../../../component/LeftTool/LeftTool'
import Foot from '../../../component/Foot/Foot'

import { ReactComponent as img } from '../../../icons/bbs/img.svg';
import { ReactComponent as bird } from '../../../icons/bbs/bird.svg';

import forum from '../../../api/bbs'
import merchantsInfo from '../../../api/yellow'




import '../components/bbs.css'

import { Search, Dropdown, InfiniteScroll, Loading } from 'antd-mobile'

export default class bbsPageList extends React.Component {
    constructor() {
        super()
        this.state = {
            breadArray: [
                {
                    name: intl.get('KUNSHILANYISHOU'),
                    path: '/main',
                    navData: '1'
                },
                {
                    name: intl.get('YISHOULUNT'),
                    path: '/bbspages',
                    navData: '2'
                },
                {
                    name: intl.get('LUNTANLIEBIE'),
                    path: '/bbspagelist',
                    navData: '2'
                }
            ],
            totalCount: 0,
            pageNum: 1,
            pageSize: 10,
            listData: [],
            // 移动端
            mainTypeList: [],
            secondaryTypeList: [],
            mainTypeName: intl.get('ZHUFENLEI'),
            cityTypeName: intl.get('QUANBUDIQU'),
            cityTypeList: [
                {
                    id: '',
                    name: intl.get('QUANBUDIQU')
                },
                {
                    id: 1,
                    name: intl.get('BULISB')
                },
                {
                    id: 2,
                    name: intl.get('HUANGJIANHAN')
                },
                {
                    id: 3,
                    name: intl.get('YANGHUANGHANHAN')
                },
                {
                    id: 4,
                    name: intl.get('KAIENSI')
                },
            ],
            sellerTypeData: [
                {
                    label: intl.get("GEREN"),
                    value: 1,
                },
                {
                    label: intl.get("SHANGJIA"),
                    value: 2,
                },
            ],
            dealtypeData: [
                {
                    label: intl.get("CHUSHOU"),
                    value: 1,
                },
                {
                    label: intl.get("QIUGOU"),
                    value: 2,
                },
                {
                    label: intl.get("ZENGSONG"),
                    value: 3,
                },
            ],
            neworoldData: [
                {
                    label: intl.get("QUANXIAN"),
                    value: 1,
                },
                {
                    label: intl.get("ERSHOU"),
                    value: 2,
                },
            ],
            industryData: [
                {
                    label: intl.get("CANGTING"),
                    value: 1,
                },
                {
                    label: intl.get("CHAOSHI"),
                    value: 2,
                },
                {
                    label: intl.get("KAFEITING"),
                    value: 3,
                },
                {
                    label: intl.get("QINGJIE"),
                    value: 4,
                },
                {
                    label: intl.get("JIUDIAN"),
                    value: 5,
                },
                {
                    label: intl.get("LIPINGDIAN"),
                    value: 6,
                },
                {
                    label: intl.get("JIAYOUZHAN"),
                    value: 7,
                },
                {
                    label: intl.get("MIANBAODIAN"),
                    value: 8,
                },
                {
                    label: intl.get("NONGCHANG"),
                    value: 9,
                },
                {
                    label: intl.get("QITAHANGYE"),
                    value: 10,
                },
            ],
            letoutTypeData: [
                {
                    label: intl.get("DANJIAN"),
                    value: 1,
                },
                {
                    label: intl.get("KETING"),
                    value: 2,
                },
                {
                    label: intl.get("ZHENGZU"),
                    value: 3,
                },
                {
                    label: intl.get("HEZHU"),
                    value: 4,
                },
                {
                    label: intl.get("ZHUANGZU"),
                    value: 5,
                },
                {
                    label: intl.get("CHUANGWEI"),
                    value: 6,
                },
            ],
            secondTypeName: intl.get('FENLEI'),
            regionName: intl.get('QUANBUDIQU'),
            sellerTypeName: intl.get('SHAIXUAN'),
            dealtypeName: intl.get('SHAIXUAN'),
            industryName: intl.get('SHAIXUAN'),
            letoutTypeName: intl.get('SHAIXUAN'),
            hasMore: true,
            phoneListData: [],
            activeKey: '',
            popvisible: false,
            adList: []

        }
    }
    componentDidMount() {
        this.initBbsData({})
        this.getBread()
        this.initCategory()
        this.getAds()
    }
    componentWillUnmount() {
        sessionStorage['SHOPSEARCHPARMS'] = ''
    }

    getAds = () => {
        merchantsInfo.advertisementList({}).then(res => res.json())
            .then(result => {
                if (result.ret === 200) {
                    let apiData = result.data.filter(item => item.type === 11)
                    this.setState({
                        adList: apiData[0]?.path ? JSON.parse(apiData[0]?.path) : [{ firstItemUrl: '', picPath: '' }],
                    })
                }
            })
    }

    initBbsData = ({
        pageSize = this.state.pageSize,
        pageNum = this.state.pageNum,
        categoryId = sessionStorage['MAINTYPE'],
        regionId = sessionStorage['CITY'],
        childId = sessionStorage['SECONDTYPE'],
        mainTitle = sessionStorage['SHOPSEARCHPARMS'],
        sort = sessionStorage['SORT'],
        industry = sessionStorage['INDUSTRY'],
        sellerType = sessionStorage['SELLERTYPE'],
        dealType = sessionStorage['DEALTYPE'],
        newOrOld = sessionStorage['BBSNEWOROLD'],
        letOutType = sessionStorage['LETOUTTYPE']
    }) => {
        forum
            .forumListWeb(
                {
                    pageNum,
                    pageSize,
                    categoryId,
                    regionId,
                    childId,
                    mainTitle,
                    sort,
                    industry,
                    sellerType,
                    dealType,
                    newOrOld,
                    letOutType
                }
            )
            .then((res) => res.json())
            .then((result) => {
                console.log("bbsresult", result);
                if (result.ret === 200) {
                    this.setState({
                        totalCount: result.data.totalCount,
                        listData: result.data.list,
                        phoneListData: result.data.list,
                        activeKey: undefined,
                    });
                }
            });
    }


    handleFilter = () => {
        this.setState({
            pageNum: 1
        }, () => {
            this.initBbsData({ pageNum: this.state.pageNum })
            this.getBread()
        })
    }

    handleChangePage = (page, pageSize) => {
        console.log(page, pageSize)
        this.setState({
            pageNum: page,
            pageSize: pageSize
        }, () => {
            this.initBbsData({})
        })
    }

    handleGotoNewBbs = () => {
        if (!JSON.parse(sessionStorage.getItem("USERDATA"))) {
            message.warning(intl.get('QINGXIANDENGLU'))
            return
        }
        this.props.history.push('/bbspagenew')
    }

    handleToDetail = (e) => {
        sessionStorage['BBSTOPICID'] = e
        let urlParms = JSON.stringify(e)
        this.props.history.push(`/bbspagedetail/${urlParms}`)
        
    }

    weatherPath = (item) => {
        if (!item.path) {
            return
        } else {
            return (
                <Icon component={img} style={{ fontSize: '.16rem', paddingLeft: '.12rem', color: '#ffffff' }} className="init-icons" />
            )
        }
    }

    getBread = () => {
        forum.forumCategoryListWeb({ categoryId: sessionStorage['MAINTYPE'], language: sessionStorage['language'], stat: 1 })
            .then(res => res.json())
            .then(result => {
                let arr = []
                arr = this.state.breadArray
                if (result.ret === 200) {
                    arr[3] = {
                        name: result.data[0].categoryName,
                        path: '/bbspagelist',
                        navData: '2'
                    }
                    this.setState({
                        breadArray: arr
                    })
                }
            })
    }


    // 移动端





    getBbsCategoryListByApi = async ({
        parentId = 0,
        language = sessionStorage['language']
    }) => {
        const result = await forum.forumCategoryListWeb({ parentId, language })
        const apiData = await result.json()
        return apiData.data.sort((item1, item2) => {
            return item1.id - item2.id
        })
    }

    initCategory = async () => {
        let a = await this.getBbsCategoryListByApi({})
        let b = await this.getBbsCategoryListByApi({ parentId: sessionStorage['MAINTYPE'] ? sessionStorage['MAINTYPE'] : 41 })
        for (let i in a) {
            a[i].columnName = a[i].categoryName
        }

        for (let j in b) {
            b[j].columnName = b[j].categoryName
        }
        if (sessionStorage['MAINTYPE'] === undefined) {
            sessionStorage['MAINTYPE'] = 41
        }
        sessionStorage['SELLERTYPE'] = ''
        sessionStorage['DEALTYPE'] = ''
        sessionStorage['INDUSTRY'] = ''
        sessionStorage['LETOUTTYPE'] = ''
        sessionStorage['SORT'] = ''
        this.setState({
            mainTypeList: a ?? [],
            secondaryTypeList: b ?? []
        }, () => {
            this.changeLang()
        })
    }

    handleChooseMainType = async (val) => {
        sessionStorage['MAINTYPE'] = val.id
        sessionStorage['SECONDTYPE'] = ''
        sessionStorage['SELLERTYPE'] = ''
        sessionStorage['DEALTYPE'] = ''
        sessionStorage['INDUSTRY'] = ''
        sessionStorage['LETOUTTYPE'] = ''
        sessionStorage['SORT'] = ''
        let b = []
        b = await this.getBbsCategoryListByApi({ parentId: val.id })
        for (let j in b) {
            b[j].columnName = b[j].categoryName
        }
        this.setState({
            secondaryTypeList: b ?? [],
            phoneListData: [],
            secondTypeName: intl.get('FENLEI'),
            regionName: intl.get('QUANBUDIQU'),
            sellerTypeName: intl.get('SHAIXUAN'),
            dealtypeName: intl.get('SHAIXUAN'),
            industryName: intl.get('SHAIXUAN'),
            letoutTypeName: intl.get('SHAIXUAN'),
        }, () => {
            this.changeLang()
            this.handleFilter()

        })
    }

    // 语言切换
    changeLang = () => {
        const mainObj = this.state.mainTypeList.find(item => {
            return Number(sessionStorage['MAINTYPE']) === item.id
        })
        const cityObj = this.state.cityTypeList.find(item => {
            if (sessionStorage['CITY'] === '') {
                return item.id === ''
            } else {
                return Number(sessionStorage['CITY']) === item.id
            }
        })
        this.setState({
            mainTypeName: mainObj?.columnName ?? intl.get('ZHUFENLEI'),
            cityTypeName: cityObj?.name
        })

    }

    // 次级分类
    handleChooseSecondType = (val) => {
        sessionStorage['SECONDTYPE'] = val.id

        this.setState({
            secondTypeName: val.columnName
        }, () => {
            this.handleFilter()
        })
    }

    // 城市选择
    handleChooseCity = (val) => {
        sessionStorage['CITY'] = val.id
        this.setState({
            regionName: val.name
        }, () => {
            this.changeLang()
            this.handleFilter()
        })
    }


    // 销售类型
    handleChooseSellerType = (val) => {
        sessionStorage['SELLERTYPE'] = val.value
        this.setState({
            sellerTypeName: val.label
        }, () => {
            this.handleFilter()
        })
    }

    // 交易类型
    handleChooseDealType = (val) => {
        sessionStorage['DEALTYPE'] = val.value
        this.setState({
            dealtypeName: val.label
        }, () => {
            this.handleFilter()
        })
    }

    // 行业
    handleChooseIndustry = (val) => {
        sessionStorage['INDUSTRY'] = val.value
        this.setState({
            industryName: val.label
        }, () => {
            this.handleFilter()
        })
    }

    // 出租方式
    handleChooseLetOut = (val) => {
        sessionStorage['LETOUTTYPE'] = val.value
        this.setState({
            letoutTypeName: val.label
        }, () => {
            this.handleFilter()
        })
    }

    // 第二个 
    filters = () => {
        switch (sessionStorage['MAINTYPE']) {
            case '11':
                return (
                    <Dropdown.Item key='more2' title={this.state.dealtypeName}>
                        <div style={{ padding: 12 }}>
                            {
                                this.state.dealtypeData.map((item) => {
                                    return (
                                        <div className="sorter_item" key={item.value} onClick={this.handleChooseDealType.bind(this, item)}>
                                            {item.label}
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </Dropdown.Item>
                )
            default:
                break
        }
    }


    // 更多筛选条件
    moreFilter = () => {
        console.log('sessionStorage[MAINTYPE', sessionStorage['MAINTYPE'])
        switch (sessionStorage['MAINTYPE']) {
            case '11':
                return (

                    <Dropdown.Item key='more1' title={this.state.sellerTypeName}>
                        <div style={{ padding: 12 }}>
                            {
                                this.state.sellerTypeData.map((item) => {
                                    return (
                                        <div className="sorter_item" key={item.value} onClick={this.handleChooseSellerType.bind(this, item)}>
                                            {item.label}
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </Dropdown.Item>


                )
            case '9':
                return (
                    <Dropdown.Item key='more3' title={this.state.industryName}>
                        <div style={{ padding: 12 }}>
                            {
                                this.state.industryData.map((item) => {
                                    return (
                                        <div className="sorter_item" key={item.value} onClick={this.handleChooseIndustry.bind(this, item)}>
                                            {item.label}
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </Dropdown.Item>
                )

            case '7':
                return (
                    <Dropdown.Item key='more4' title={this.state.letoutTypeName}>
                        <div style={{ padding: 12 }}>
                            {
                                this.state.letoutTypeData.map((item) => {
                                    return (
                                        <div className="sorter_item" key={item.value} onClick={this.handleChooseLetOut.bind(this, item)}>
                                            {item.label}
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </Dropdown.Item>
                )
            default:
                break;
        }
    }


    InfiniteScrollContent = () => {
        return (
            <>
                {this.state.hasMore ? (
                    <>
                        <span>Loading</span>
                        <Loading />
                    </>
                ) : (
                    <span>--- {intl.get('ZUIHOUYITIAO')} ---</span>
                )}
            </>
        )
    }

    loadMore = async () => {

        let res = await forum.forumListWeb(
            {
                pageSize: this.state.pageSize,
                pageNum: this.state.pageNum,
                categoryId: sessionStorage['MAINTYPE'],
                regionId: sessionStorage['CITY'],
                childId: sessionStorage['SECONDTYPE'],
                mainTitle: sessionStorage['SHOPSEARCHPARMS'],
                sort: sessionStorage['SORT'],
                industry: sessionStorage['INDUSTRY'],
                sellerType: sessionStorage['SELLERTYPE'],
                dealType: sessionStorage['DEALTYPE'],
                newOrOld: sessionStorage['BBSNEWOROLD'],
                letOutType: sessionStorage['LETOUTTYPE']
            }
        )
        let result = await res.json()
        console.log('1212', 1212)
        console.log('result.data.totalCount', result.data.totalCount)
        let arr = []
        arr = this.state.phoneListData

        if (result.ret === 200 && this.state.pageNum < result.data.pageCount + 1) {
            this.setState({
                pageNum: this.state.pageNum + 1,
                totalCount: result.data.totalCount,
                phoneListData: uniqBy([...arr, ...result.data.list], 'id'),
            });
        } else {
            this.setState({
                hasMore: false
            })
        }

    }

    handleSelect = (e) => {
        console.log('e', e)
        this.setState({
            activeKey: e
        })
    }

    handleBack = () => {
        this.props.history.push('/bbspages')
    }

    handleSetVisible = () => {
        this.setState({
            popvisible: false
        }, () => {
            this.initBbsData({})
        })
    }

    handleFocus = (e) => {
        this.setState({
            popvisible: true
        })
        this.$phoneSearchEvent.searchFocus()
    }

    searchEvevnt = (element) => {
        this.$phoneSearchEvent = element
    }

    judgeIsExtentd = (item) => {
        if (item.isExtend === 1) {
            return (
                <span className="bbs_main_content_top_row_item_num">{intl.get('TUIGUANG')}</span>
            )
        }
    }

    render() {
        document.title = "EQLD昆士兰易搜论坛BBS";
        document.querySelector('meta[property="og:title"]').setAttribute('content', 'EQLD昆士兰易搜论坛BBS');
        document.querySelector('meta[property="og:description"]').setAttribute('content', '找租房、找生意，找房源，找工作，找二手，选易搜！');
        document.querySelector('meta[itemprop="description"]').setAttribute('content', '找租房、找生意，找房源，找工作，找二手，选易搜！');
        document.querySelector('meta[property="og:type"]').setAttribute('content', 'website');
        document.querySelector('meta[property="og:image"]').setAttribute('content', 'http://icon.mobanwang.com/UploadFiles_8971/200910/20091011134333685.png');
        document.querySelector('meta[itemprop="image"]').setAttribute('content', 'http://icon.mobanwang.com/UploadFiles_8971/200910/20091011134333685.png');
        document.querySelector('meta[itemprop="name"]').setAttribute('content', 'EQLD昆士兰易搜论坛BBS');
        return (
            <>
                <div className="main_content">
                    <Nav history={this.props.history} props={this.props} />
                    <Banner type="2" history={this.props.history} setBannerSearch={this.handleFilter} />
                    <FilterComponent type="2" filterAction={this.handleFilter} />

                    <div className="bbs_ads">
                        <div className="bbs_ads_item">
                            <a href={this.state.adList[0]?.firstItemUrl} target="_blank">
                                <Image
                                    width='12rem'
                                    height='1.2rem'
                                    preview={false}
                                    src={this.state.adList[0]?.picPath}
                                />
                            </a>
                        </div>


                    </div>


                    <BreadCrumb history={this.props.history} breadData={this.state.breadArray} style={{ paddingBottom: '0' }} />
                    <div className="bbs_list_top">
                        <div className="bbs_main_content_top_new">
                            <div className="bbs_main_content_top_new_button" onClick={this.handleGotoNewBbs}>
                                <Icon component={bird} style={{ fontSize: '.16rem', paddingRight: '.12rem' }} className="init-icons" />
                                {intl.get('FABIAOXINTIE')}
                            </div>
                            <div className="bbs_main_content_top_new_right">
                                <APagination pageNum={this.state.pageNum} total={this.state.totalCount} current={this.state.pageNum} changePage={this.handleChangePage} />
                            </div>
                        </div>
                    </div>

                    <div className="bbs_list_content">


                        <div className="bbs_main_content_context">

                            <div className="bbs_main_content_top_column">
                                <div className="bbs_main_content_top_column_item">
                                    <div className="bbs_main_content_top_column_item_text">{intl.get('BIAOTIE')}</div>
                                </div>
                                <div className="bbs_main_content_top_column_item">{intl.get('ZUOZHESHIJIAN')}</div>
                                <div className="bbs_main_content_top_column_item">{intl.get('HUIFUCHAKAN')}</div>
                            </div>


                            {
                                this.state.listData.map((item) => {
                                    return (
                                        <div className="bbs_main_content_context_item" key={item.id} >

                                            <div className="bbs_main_content_context_item_top" onClick={this.handleToDetail.bind(this, item.id)}>
                                                <div className="bbs_main_content_context_item_top_item">
                                                    {item.mainTitle}
                                                    <span className="bbs_main_content_top_row_item_num">[{item.replyNum}]</span>
                                                    {
                                                        this.weatherPath(item)
                                                    }
                                                </div>
                                                <div className="bbs_main_content_context_item_top_item">
                                                    <div>
                                                        {item.customerName}
                                                    </div>
                                                    <div>{timeFormat(item.createDate)}</div>
                                                </div>
                                                <div className="bbs_main_content_context_item_top_item">
                                                    <span className="bbs_main_content_top_row_item_arr">{item.replyNum}</span>/{item.clickNum}


                                                </div>
                                            </div>

                                            <div className="bbs_main_content_context_item_content">
                                                <div className="bbs_main_content_context_item_content_text" onClick={this.handleToDetail.bind(this, item.id)}>
                                                    <div className="bbs_main_content_context_item_content_text_content">
                                                        <div className="bbs_main_content_context_item_content_text" dangerouslySetInnerHTML={{ __html: item.context }}></div>
                                                    </div>

                                                    <div className="bbs_main_content_context_item_content_seemore">[{intl.get('CHAKANGENGDUO')}]</div>

                                                </div>
                                                <div className="bbs_main_content_context_item_content_imgs">

                                                    {
                                                        item.path?.split(",")?.map((item2, index2) => {
                                                            return (
                                                                <div className="bbs_main_content_context_item_content_imgs_item" key={index2}>
                                                                    <Image
                                                                        preview={true}
                                                                        src={item2}
                                                                        fallback="data:image/png;base64,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"
                                                                    />
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                        </div>
                        <div className="bbs_paginon">
                            <APagination pageNum={this.state.pageNum} total={this.state.totalCount} current={this.state.pageNum} changePage={this.handleChangePage} />
                        </div>
                    </div>
                    <Foot history={this.props.history} />

                </div>

                {/* 移动端=========================================================================================================================================================================================================================================================================== */}
                <div className="phone_content bbslist">
                    <div className="bbslist_search">
                        <LeftOutlined onClick={this.handleBack} />
                        <div className="bbslist_search_item">
                            <Search placeholder={intl.get('KUNSHILANYISHOU')} className="phone_bbs_index_search_input_item" onFocus={this.handleFocus} />
                            <PopupSearch visible={this.state.popvisible} type="2" history={this.props.history} setVisible={this.handleSetVisible} searchEvevnt={this.searchEvevnt} />

                        </div>
                    </div>
                    <div className="bbslist_filter">
                        <Dropdown onChange={this.handleSelect} activeKey={this.state.activeKey}>
                            <Dropdown.Item key='sorter' title={this.state.mainTypeName}>
                                <div style={{ padding: 12, display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                                    {
                                        this.state.mainTypeList.map((item) => {
                                            return (
                                                <div className="sorter_item" key={item.id} onClick={this.handleChooseMainType.bind(this, item)}>
                                                    {item.columnName}
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </Dropdown.Item>
                            <Dropdown.Item key='bizop' title={this.state.secondTypeName}>
                                <div style={{ padding: 12, display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                                    {
                                        this.state.secondaryTypeList.map((item) => {
                                            return (
                                                <div className="sorter_item" key={item.id} onClick={this.handleChooseSecondType.bind(this, item)}>
                                                    {item.columnName}
                                                </div>
                                            )
                                        })
                                    }


                                </div>
                            </Dropdown.Item>
                            <Dropdown.Item key='more' title={this.state.regionName}>
                                <div style={{ padding: 12, display: 'flex', alignItems: 'center', flexWrap: 'wrap' }}>
                                    {
                                        this.state.cityTypeList.map((item) => {
                                            return (
                                                <div className="sorter_item" key={item.id} onClick={this.handleChooseCity.bind(this, item)}>
                                                    {item.name}
                                                </div>
                                            )

                                        })
                                    }
                                </div>
                            </Dropdown.Item>
                            {
                                this.moreFilter()
                            }
                            {
                                this.filters()
                            }

                        </Dropdown>

                    </div>



                    <div className="phone_bbs_content bbs_list_content">

                        {
                            this.state.phoneListData.map((item) => {
                                return (
                                    <div className="phone_content_item" key={item.id} >
                                        <div className="phone_content_item_top" onClick={this.handleToDetail.bind(this, item.id)}>
                                            <Avatar size={30} icon={<UserOutlined />} src={item.customerPath} />
                                            <div className="phone_content_item_title">
                                                <div className="phone_content_item_title_text">{item.mainTitle} {this.judgeIsExtentd(item)}</div>
                                                <div className="phone_content_item_title_time">{item.customerName} -- {timeFormat(item.createDate)}</div>
                                            </div>

                                            <div className="phone_content_item_tag">
                                                <div className="phone_content_item_tag_btn_none">
                                                    {/* {intl.get('ZHIDING')} */}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="phone_content_item_context" dangerouslySetInnerHTML={{ __html: item.context }} onClick={this.handleToDetail.bind(this, item.id)}></div>
                                        <span className="see_more" onClick={this.handleToDetail.bind(this, item.id)}>{'....' + intl.get('CHAKANGENGDUO')}</span>

                                        <div className="phone_content_item_imgs">

                                            {
                                                item.path?.split(",")?.map((item2, index2) => {
                                                    return (
                                                        <div className="phone_content_item_imgs_item" key={index2}>
                                                            <Image

                                                                preview={true}
                                                                src={item2}
                                                                fallback="data:image/png;base64,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"
                                                            />
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                        <div className="phone_content_item_bottom">
                                            <div className="phone_content_item_bottom_content">
                                                <MessageOutlined /> {item.replyNum}   <HeartOutlined /> {item.clickNum}
                                            </div>
                                        </div>
                                    </div>
                                )
                            })
                        }
                        <InfiniteScroll loadMore={this.loadMore} hasMore={this.state.hasMore} threshold={-60}>
                            {this.InfiniteScrollContent()}
                        </InfiniteScroll>



                    </div>
                </div>
            </>
        )
    }
}